var AddDocSecRootIdToDocSecChaptersAndSections, BULK_DOCS_CHUNK_SIZE, ChapterDoc, MDA_ROOT_TOPIC_PREFIX, MINI_DS_ROOT_PREFIX, Migration, RootDoc, SectionDoc, W, chunk, convertRowsToArray, fetchByPrefix, mediator, migrationName, sequence, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Migration = require('./migration');

mediator = require('mediator');

ChapterDoc = require('lib/db_docs/document_sections_v2_chapter_doc');

RootDoc = require('lib/db_docs/document_sections_v2_root_doc');

SectionDoc = require('lib/db_docs/document_sections_v2_section_doc');

W = require('when');

sequence = require('when/sequence');

chunk = require('lodash').chunk;

convertRowsToArray = require('lib/app_utils').convertRowsToArray;

_ref = require('lib/doc_prefixes'), MDA_ROOT_TOPIC_PREFIX = _ref.mdaRootTopicDoc, MINI_DS_ROOT_PREFIX = _ref.miniDSRootDoc;

migrationName = 'add_doc_sec_root_id_to_doc_sec_chapters_and_sections';

BULK_DOCS_CHUNK_SIZE = 200;

fetchByPrefix = function(adapter, projectId, prefix) {
  return adapter.fetchWithKeyPrefix(projectId, prefix)["catch"](function(err) {
    if (err.status !== 404) {
      throw err;
    }
    return {
      rows: []
    };
  });
};

module.exports = AddDocSecRootIdToDocSecChaptersAndSections = (function(_super) {
  __extends(AddDocSecRootIdToDocSecChaptersAndSections, _super);

  function AddDocSecRootIdToDocSecChaptersAndSections() {
    AddDocSecRootIdToDocSecChaptersAndSections.__super__.constructor.call(this, false);
  }

  AddDocSecRootIdToDocSecChaptersAndSections.prototype.up = function(project) {
    var adapter, projectId;
    AddDocSecRootIdToDocSecChaptersAndSections.__super__.up.call(this, project);
    projectId = project.id;
    adapter = mediator.services.storePersistenceAdapter;
    return W.all([
      RootDoc.at(projectId).fetch()["catch"](function(err) {
        if (err.status !== 404) {
          throw err;
        }
        return null;
      }), fetchByPrefix(adapter, projectId, MDA_ROOT_TOPIC_PREFIX), fetchByPrefix(adapter, projectId, MINI_DS_ROOT_PREFIX), ChapterDoc.at(projectId).fetchMany(), SectionDoc.at(projectId).fetchMany()
    ]).then(function(_arg) {
      var chapterById, chapterDocs, collectFromChapter, docsChunks, docsToUpdate, mdaRootRows, miniDsRootRows, rootDocs, sectionById, sectionDocs, standardRootDoc, updatedDocs, _ref1, _ref2;
      standardRootDoc = _arg[0], (_ref1 = _arg[1], mdaRootRows = _ref1.rows), (_ref2 = _arg[2], miniDsRootRows = _ref2.rows), chapterDocs = _arg[3], sectionDocs = _arg[4];
      rootDocs = _.compact([standardRootDoc]).concat(convertRowsToArray(mdaRootRows.concat(miniDsRootRows)));
      chapterById = _.indexBy(chapterDocs, '_id');
      sectionById = _.indexBy(sectionDocs, '_id');
      docsToUpdate = {};
      collectFromChapter = function(rootId, chapterId) {
        var chapterDoc, _ref3, _ref4;
        chapterDoc = chapterById[chapterId];
        if (!chapterDoc) {
          return;
        }
        if (chapterDoc.docSecRootId !== rootId) {
          docsToUpdate[chapterDoc._id] = _.extend({}, chapterDoc, {
            docSecRootId: rootId,
            rev_author: "project_migration/" + migrationName
          });
        }
        _.each((_ref3 = chapterDoc.sections) != null ? _ref3 : [], function(sectionId) {
          var sectionDoc;
          sectionDoc = sectionById[sectionId];
          if (!sectionDoc) {
            return;
          }
          if (sectionDoc.docSecRootId !== rootId) {
            return docsToUpdate[sectionDoc._id] = _.extend({}, sectionDoc, {
              docSecRootId: rootId,
              rev_author: "project_migration/" + migrationName
            });
          }
        });
        return _.each((_ref4 = chapterDoc.subchapters) != null ? _ref4 : [], function(subchapterId) {
          return collectFromChapter(rootId, subchapterId);
        });
      };
      _.each(rootDocs, function(rootDoc) {
        var _ref3;
        return _.each((_ref3 = rootDoc.chaptersOrder) != null ? _ref3 : [], function(chapterId) {
          return collectFromChapter(rootDoc._id, chapterId);
        });
      });
      updatedDocs = _.values(docsToUpdate);
      if (_.isEmpty(updatedDocs)) {
        return W.resolve();
      }
      docsChunks = chunk(updatedDocs, BULK_DOCS_CHUNK_SIZE);
      return sequence(_.map(docsChunks, function(docsChunk) {
        return function() {
          return adapter.bulkDocs(projectId, docsChunk);
        };
      }));
    });
  };

  return AddDocSecRootIdToDocSecChaptersAndSections;

})(Migration);
